import * as Sentry from '@sentry/nextjs';

const pingServer = async (
  url: string,
  registrationDetails?: string,
): Promise<boolean> => {
  try {
    await fetch(url, { mode: 'no-cors' });
    return true;
  } catch (err: unknown) {
    const error = new Error(
      JSON.stringify({
        error: String(err),
        registrationDetails,
      }),
    );
    Sentry.captureException(error);
    return false;
  }
};

export default pingServer;
